import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const entHorarioClaseDiasApi = `${baseUrl}/entidad-horario-clase-dias`;

export const allEntHorDiasService = async (params) => {
  const res = await axios.get(entHorarioClaseDiasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntHorDiasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entHorarioClaseDiasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entHorarioClaseDiasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntHorDiasService = async (id) => {
  const res = await axios.get(`${entHorarioClaseDiasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntHorDiasService = async (id) => {
  const res = await axios.delete(`${entHorarioClaseDiasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
